import React, { useContext } from "react";
import "./MusicPlayer.scss";
import config from "config";
import { Stack, Typography } from "@mui/material";
import Row from "components/layout/Row";
import { MusicPlayerContext } from "context/MusicPlayerProvider";

function MusicPlayer() {
  const musicContext = useContext(MusicPlayerContext);
  const moreMusicFeature = config.features.moreMusic;
  const content = moreMusicFeature ? (
    <div className="audio-box">
      <Row justifyContent="space-between">
        <button className="side-button">&#9204;</button>
        <Stack alignItems="center" className="center-box">
          <Typography variant="caption">How Charming is the Place</Typography>
          <button onClick={musicContext.togglePlaying} className="play-button">
            <b>{musicContext.isPlaying ? "Pause" : "Play"}</b>
          </button>
        </Stack>
        <button className="side-button">&#9205;</button>
      </Row>
    </div>
  ) : (
    <div className="audio-box">
      <Stack alignItems="center" className="center-box">
        <Typography variant="caption">How Charming is the Place</Typography>
        <button onClick={musicContext.togglePlaying} className="play-button">
          <b>{musicContext.isPlaying ? "Pause" : "Play"}</b>
        </button>
      </Stack>
    </div>
  );
  return content;
}

export default MusicPlayer;
